import { InvestmentPipeline } from '@/pages/pipelines/investment/investment-pipeline';

import { InvestingBoardTabRoot } from './InvestingBoardTab.styled';

export const InvestingBoardTab = () => (
  <InvestingBoardTabRoot>
    <InvestmentPipeline />
  </InvestingBoardTabRoot>
);
